import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MessageCircle, Mail } from 'lucide-react';
import { profile, navLinks } from '../mock';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1F1B16] text-[#F4EDE2] pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-[#B8806E] grid place-items-center font-serif text-[20px] text-[#FAF4E8] leading-none">
                k
              </span>
              <div>
                <p className="font-serif text-[22px] tracking-tight">Karina Negrín</p>
                <p className="text-[11px] tracking-[0.28em] uppercase text-[#D4B5A6]">
                  Psicología · Lactancia
                </p>
              </div>
            </div>
            <p className="mt-6 max-w-[420px] text-[15px] leading-[1.75] text-[#F4EDE2]/75 font-light">
              {profile.shortBio}
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[12px] tracking-[0.22em] uppercase text-[#D4B5A6] mb-5">
              Navegación
            </p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  {l.external ? (
                    <Link
                      to={l.href}
                      className="text-[15px] text-[#F4EDE2]/85 hover:text-[#D4B5A6] transition-colors duration-300"
                    >
                      {l.label}
                    </Link>
                  ) : (
                    <a
                      href={l.href}
                      className="text-[15px] text-[#F4EDE2]/85 hover:text-[#D4B5A6] transition-colors duration-300"
                    >
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-[12px] tracking-[0.22em] uppercase text-[#D4B5A6] mb-5">
              Contacto
            </p>
            <ul className="space-y-3 text-[15px] text-[#F4EDE2]/85">
              <li>{profile.address}</li>
              <li>
                <a className="hover:text-[#D4B5A6] transition-colors" href={`mailto:${profile.email}`}>
                  {profile.email}
                </a>
              </li>
              <li>
                <a className="hover:text-[#D4B5A6] transition-colors" href={profile.whatsapp} target="_blank" rel="noreferrer">
                  {profile.whatsappLabel}
                </a>
              </li>
            </ul>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={profile.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full border border-[#F4EDE2]/25 grid place-items-center hover:bg-[#F4EDE2] hover:text-[#1F1B16] transition-colors duration-300"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a
                href={profile.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full border border-[#F4EDE2]/25 grid place-items-center hover:bg-[#F4EDE2] hover:text-[#1F1B16] transition-colors duration-300"
              >
                <Facebook size={16} strokeWidth={1.5} />
              </a>
              <a
                href={profile.whatsapp}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="w-10 h-10 rounded-full border border-[#F4EDE2]/25 grid place-items-center hover:bg-[#F4EDE2] hover:text-[#1F1B16] transition-colors duration-300"
              >
                <MessageCircle size={16} strokeWidth={1.5} />
              </a>
              <a
                href={`mailto:${profile.email}`}
                aria-label="Email"
                className="w-10 h-10 rounded-full border border-[#F4EDE2]/25 grid place-items-center hover:bg-[#F4EDE2] hover:text-[#1F1B16] transition-colors duration-300"
              >
                <Mail size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#F4EDE2]/10 flex items-center justify-between flex-wrap gap-4 text-[12px] text-[#F4EDE2]/55">
          <p>© {year} Karina Negrín. Hecho con cuidado.</p>
          <p className="font-script text-[20px] text-[#D4B5A6]">acompañar es un acto de amor</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
